import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import { resetState, setPOFilterFields, setAuthProperty } from '../js/actions/index';
import { PersonCircle, Globe, BoxArrowRight } from 'react-bootstrap-icons';
import { Nav, Navbar, NavDropdown, Popover, OverlayTrigger } from "react-bootstrap";

import I18N from "../js/i18n";
import {getLocaleLabel} from "../js/global";
import {
    EN, ZH_HK, I18N_LOCALES, RESTAURANT, SUPPLIER, UAT
  } from "../constants/GlobalConstant";

import { Can } from './Can';

function mapDispatchToProps(dispatch) {
    return {
      resetState: payload => dispatch(resetState(payload)),
      setPOFilterFields: type => dispatch(setPOFilterFields(type)),
      setAuthProperty: type => dispatch(setAuthProperty(type))
    };
}

const PLACEMENT = window.matchMedia("(max-width: 767px)").matches
  ? "right"
  : "bottom";

class NavbarComponent extends React.Component {

    constructor(props) {
        super(props);
        this.prevScrollPos = window.pageYOffset;
        this.navRef = React.createRef();
        this.state = {
          navbarVisible: true,
        };
      }
    
      componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
      }
    
      componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
      }
    
      handleScroll = () => {
        const currentScrollPos = window.pageYOffset;
      
        if (currentScrollPos > this.prevScrollPos) {
          // Scrolling down
          this.setState({ navbarVisible: false });
        } else {
          // Scrolling up
          this.setState({ navbarVisible: true });
        }
      
        this.prevScrollPos = currentScrollPos;
      };

    handleLogout = (e) => {
        e.preventDefault();
        this.props.resetState().then( () => {
            if(this.props.auth.mode === RESTAURANT) {
                this.props.history.push('/login/restaurant');
            } else {
                this.props.history.push('/login/supplier');
            }
        });
    }

    setPOFilterFields = () => {
        this.props.setPOFilterFields([]);
    }

    handleSelectLocale = (value) => {
        this.props.setAuthProperty({
            "prop":"locale",
            "value":value
        }).then( () => {
            if(this.props.onClickLocale) {
                this.props.onClickLocale();
            }       
        });
    }

    render() {
        const { navbarVisible } = this.state;
        const navbarClasses = `no-print navbar ${navbarVisible ? 'navbar-scroll-show' : 'navbar-scroll-hide'}`;
        return (
            
            <Navbar className={navbarClasses} bg="primary-light" expand="lg" ref={this.navRef}>
            <Navbar.Brand href="/home"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="240.23 183.43 69.54 96.31" width="25" height="25" fill="#28b46e" style={{verticalAlign: "top"}}><path d="m 267.16 279.743 l -17.419 0 l 0 -22.679 c 4.169 -4.645 9.975 -8.099 17.419 -10.362 l 0 33.041 z m 42.61 -65.914 c 0 9.231 -2.531 15.93 -7.593 20.099 l 0 45.815 l -17.509 0 l 0 -39.205 l -5.806 1.072 l -5.985 1.072 c -4.645 1.013 -8.575 2.174 -11.791 3.484 c -8.754 3.633 -15.126 9.737 -19.116 18.312 c -3.871 -15.245 -1.281 -25.667 7.771 -31.265 l 0 -20.853 c 0 -13.101 1.876 -16.213 5.628 -21.334 c 3.752 -5.062 10.421 -7.593 20.009 -7.593 c 9.886 0 16.824 2.471 20.814 7.414 c 3.99 4.943 5.985 8.114 5.985 21.513 l 0 3.434 c -4.347 2.204 -10.184 4.11 -17.509 5.717 l 0 -10.456 c 0 -7.086 -0.625 -7.91 -1.875 -10.471 c -1.489 -2.322 -3.752 -3.484 -6.789 -3.484 c -3.335 0 -5.628 1.191 -6.879 3.573 c -1.31 2.382 -1.965 3.176 -1.965 10.382 l 0 16.173 l 5.538 -0.982 l 5.539 -0.983 c 4.645 -0.834 8.426 -1.637 11.345 -2.412 c 8.635 -2.144 15.364 -5.151 20.188 -9.022 z"></path></svg><I18N type="ui" path="AGORA_HUB" def="AGORA HUB"/></Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="me-auto">

                {/*<Nav.Link href="/home">Home</Nav.Link>*/}

                {/*this.props.auth.mode === "restuarantxxx" &&
                <NavDropdown title="Restaurant Administration" id="restaurant-administration-nav-dropdown">
                    <NavDropdown.Item href="/purchase-order-template">Purchase Order Template</NavDropdown.Item>
                </NavDropdown>
                */}
                
                {(this.props.auth.mode === SUPPLIER && Object.keys(this.props.auth.ui.supplierAdmin).length > 0) &&
                <Can I="view" this="AdministrationMenu">
                <NavDropdown title="Administration" id="supplier-administration-nav-dropdown" renderMenuOnMount={true}>
                    <>
                    {/*<NavDropdown.Item href="/supplier-accounts">Accounts</NavDropdown.Item>*/}
                    {this.props.auth.ui.supplierAdmin.customersImport &&
                        <>
                        <Can I="manage" a="CustomerImport">
                            <NavDropdown.Item href="/supplier-customers">Customer Import</NavDropdown.Item>
                            <NavDropdown.Divider />
                        </Can>
                        </> 
                    }

                    {this.props.auth.ui.supplierAdmin.inventoryImport && 
                        <Can I="manage" a="ProductImport">
                            <NavDropdown.Item href="/supplier-inventory-import">Product Import</NavDropdown.Item>
                        </Can>
                    }

                    {this.props.auth.ui.supplierAdmin.inventoryManage && 
                        <Can I="manage" a="Products">
                            <NavDropdown.Item href="/supplier-inventory-manage">Product Manage</NavDropdown.Item>
                        </Can>
                    }
                    
                    {this.props.auth.ui.supplierAdmin.inventoryBranchProductMapping && 
                        <Can I="manage" a="BranchProductMappings">
                            <NavDropdown.Item href="/supplier-inventory-branch-product-mapping">Branch Product Mapping</NavDropdown.Item>
                        </Can>
                    }
                    
                    {/*process.env.REACT_APP_ENV !== "uat" &&
                    <NavDropdown.Item href="/supplier-data-operations">Data Operatations</NavDropdown.Item>
                    */}

                    {this.props.auth.ui.purchaseOrders.logisticsPickDelivery && 
                        <>
                        <Can I="manage" a="POImportConfig">
                            <NavDropdown.Divider />
                            <NavDropdown.Item href="/jm-purchase-order-import-register">PO Import Config</NavDropdown.Item>
                        </Can>
                        <Can I="manage" a="LogisticsConfig">
                            <NavDropdown.Divider />
                            <NavDropdown.Item href="/supplier-logistics">Logistics Config</NavDropdown.Item>
                        </Can>
                        </>
                    }
                    </>
                </NavDropdown>
                </Can>
                }

                <NavDropdown title={<I18N type="ui" path="PURCHASE_ORDERS" def="Purchase Orders"/>} id="purchase-orders-nav-dropdown" renderMenuOnMount={true}>
                    {this.props.auth.mode === RESTAURANT &&
                    <>
                    {/*<NavDropdown.Item href="/purchase-orders-restuarant">Receipt</NavDropdown.Item>*/}
                    
                    <NavDropdown.Item 
                        href={`/purchase-orders/${this.props.auth.poApproval ? "pending-approval" : "approved"}`}
                        onClick={() => this.setPOFilterFields()}
                    >
                        <I18N type="ui" path="PURCHASE_ORDERS_LIST" def="Purchase Orders List"/>
                    </NavDropdown.Item>  

                    {this.props.auth.ui.purchaseOrders.export && <NavDropdown.Item href="/purchase-orders-export">Purchase Order Export</NavDropdown.Item>}
                    
                    {/*<NavDropdown.Item href="/stock-in-report-export">Stock In Report Export</NavDropdown.Item>*/}
                    </>
                    }

                    {this.props.auth.mode === SUPPLIER &&
                    <>
                    <NavDropdown.Item 
                        href={`/purchase-orders/${this.props.auth.poApproval ? "pending-approval" : "approved"}`}
                        onClick={() => this.setPOFilterFields()}
                    >
                        <I18N type="ui" path="PURCHASE_ORDERS_LIST" def="Purchase Orders List"/>
                    </NavDropdown.Item>    
                    {this.props.auth.ui.purchaseOrders.create && <NavDropdown.Item href="/purchase-order-create">Purchase Order Create</NavDropdown.Item>}

                    {this.props.auth.ui.purchaseOrders.create && 
                        <Can I="manage" a="PurchaseOrderImport">
                            <NavDropdown.Item href="/jm-purchase-order-import">Purchase Order Import</NavDropdown.Item>
                        </Can>
                    }
                    {this.props.auth.ui.purchaseOrders.logisticsPickDelivery && 
                        <Can I="manage" a="PurchaseOrderPending">
                            <NavDropdown.Item href="/logistics/order-intelligence">Purchase Order Pending</NavDropdown.Item>
                        </Can>
                    }
                    </>
                    }
                </NavDropdown>

                {this.props.auth.ui.purchaseOrders.logisticsPickDelivery &&
                <NavDropdown title="Logistics" renderMenuOnMount={true}>
                    <NavDropdown.Item href="/logistics/pick-delivery">Pick & Delivery</NavDropdown.Item>
                </NavDropdown>
                }
                        {this.props.auth.mode === SUPPLIER &&
                            <Can I="view" a="BusinessIntelligenceMenu">
                                <NavDropdown title="Business Intelligence" renderMenuOnMount={true}>
                                        <Can I="view" a="PurchaseOrderReport">
                                            <NavDropdown.Item href="/bi/purchase-order">Purchase Order Report</NavDropdown.Item>
                                        </Can>
                                        <Can I="view" a="ProductSortOrder">
                                            <NavDropdown.Item href="/bi/product-sort">Product Sort Order</NavDropdown.Item>
                                        </Can>
                                </NavDropdown>
                            </Can>
                        }
                {/*this.props.auth.isReceipt &&
                <NavDropdown title="Goods Receipt" id="goods-receipt-nav-dropdown">
                    <NavDropdown.Item href="/goods-receipt-list/complete">Goods Receipt List</NavDropdown.Item>
                </NavDropdown>
                */}
                </Nav>
                {/*
                <Nav>
                    <NavDropdown title={<span><Globe size={16} className="mb-1 mr-1" /> English</span>} id="language-nav-dropdown">
                        <NavDropdown.Item href="#en">English</NavDropdown.Item>
                        <NavDropdown.Item href="#zh_TW">繁體中文</NavDropdown.Item>
                    </NavDropdown>
                </Nav>
                */}
                
                {/* I18N temporary env condition */}
                <Nav>
                <Can I="view" a="Locales">
                <NavDropdown 
                title={<span><Globe size={16} className="mb-1 me-1" /> {getLocaleLabel(this.props.auth.locale)}</span>} 
                renderMenuOnMount={true}
                id="language-nav-dropdown"
                >
                    {I18N_LOCALES.map( (obj, index) => {return (<NavDropdown.Item key={index} onClick={ () => this.handleSelectLocale(`${obj.locale}`) }>{obj.label}</NavDropdown.Item>)
                    })}
                    {this.props.auth.mode === RESTAURANT && <><NavDropdown.Divider /><NavDropdown.Item href="/i18n/translations">Translations</NavDropdown.Item></>}
                </NavDropdown>
                </Can>
                
                
                <Nav.Link>
                    <OverlayTrigger 
                        trigger="click" 
                        placement={PLACEMENT}
                        overlay={
                            <Popover id="popover-basic">
                                <Popover.Header as="h3">{this.props.auth.businessName ? this.props.auth.businessName : this.props.auth.supplierName}</Popover.Header>
                                <Popover.Body>
                                <span style={{display:"block"}}>{this.props.auth.operatorName}</span>
                                <span style={{display:"block", fontStyle:"Italic"}}>{this.props.auth.role}</span>
                                <Nav.Link href="/" onClick={this.handleLogout}><BoxArrowRight size={20} className="mb-1 me-1" /><I18N type="ui" path="LOGOUT" def="Logout"/></Nav.Link>
                                </Popover.Body>
                            </Popover>
                        }
                        rootClose={true}
                    >
                        <PersonCircle size={16} className="mb-1 me-1" />
                    </OverlayTrigger>
                </Nav.Link>
                </Nav>
            </Navbar.Collapse>
            </Navbar>
        );
    }
}

const mapStateToProps = state => {
    const {auth} = state;
    return { auth: auth };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(NavbarComponent));